import { Injectable } from '@angular/core';

import { RecordData } from '../../../types';

interface CachedSectionRecords {
  detailedRecords: RecordData[];
  listRecords: RecordData[];
  savedAt: number;
}

@Injectable({ providedIn: 'root' })
export class TomassSummaryCacheService {
  private readonly sectionRecords = new Map<string, CachedSectionRecords>();

  getDetailedRecords(sectionId: string): RecordData[] | undefined {
    return this.sectionRecords.get(sectionId)?.detailedRecords;
  }

  setDetailedRecords(sectionId: string, records: RecordData[]): void {
    const current = this.sectionRecords.get(sectionId);
    if (current) {
      this.sectionRecords.set(sectionId, {
        ...current,
        detailedRecords: [...records],
        savedAt: Date.now(),
      });
      return;
    }

    this.sectionRecords.set(sectionId, {
      detailedRecords: [...records],
      listRecords: [],
      savedAt: Date.now(),
    });
  }

  getListRecords(sectionId: string): RecordData[] | undefined {
    return this.sectionRecords.get(sectionId)?.listRecords;
  }

  setListRecords(sectionId: string, records: RecordData[]): void {
    const current = this.sectionRecords.get(sectionId);
    if (current) {
      this.sectionRecords.set(sectionId, {
        ...current,
        listRecords: [...records],
        savedAt: Date.now(),
      });
      return;
    }

    this.sectionRecords.set(sectionId, {
      detailedRecords: [],
      listRecords: [...records],
      savedAt: Date.now(),
    });
  }

  clear(sectionId?: string): void {
    if (!sectionId) {
      this.sectionRecords.clear();
      return;
    }
    this.sectionRecords.delete(sectionId);
  }

  getSavedAt(sectionId: string): number | null {
    return this.sectionRecords.get(sectionId)?.savedAt ?? null;
  }
}
